import * as React from "react";
import "./App.css";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import HideAppBar from "./HideAppBar";
import TopImageCarousel from "./TopImageCarousel";
import BottomImageCarousel from "./BottomImageCarousel";
import TopSection from "./TopSection";
import { StaffedHoursAndClasses } from "./StaffedHoursAndClasses";
import { FeesAndPricing } from "./FeesAndPricing";
import { JoinNow } from "./JoinNow";
import Socials from "./Socials";

const theme = createTheme({
  palette: { mode: "dark" },
  typography: {
    fontFamily: "var(--cp-font)",
    button: { textTransform: "none", fontWeight: 700, fontSize: "0.9375rem" },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: "var(--cp-bg)", color: "var(--cp-text)" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          minHeight: 48,
          padding: "12px 24px",
          borderRadius: 10,
          "&:focus-visible": { outline: "3px solid var(--cp-focus)", outlineOffset: 4 },
        },
        contained: {
          color: "var(--cp-accent-fg)",
          backgroundColor: "var(--cp-accent)",
          "&:hover": { backgroundColor: "var(--cp-accent-hover)" },
        },
        outlined: {
          color: "var(--cp-text)",
          borderColor: "var(--cp-border-strong)",
          "&:hover": {
            borderColor: "var(--cp-accent)",
            backgroundColor: "var(--cp-accent-soft)",
          },
        },
        text: {
          color: "var(--cp-text)",
          "&:hover": { backgroundColor: "var(--cp-accent-soft)" },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          width: 44,
          height: 44,
          color: "var(--cp-text)",
          "&:hover": { backgroundColor: "var(--cp-accent-soft)", color: "var(--cp-link)" },
          "&:focus-visible": { outline: "3px solid var(--cp-focus)", outlineOffset: 4 },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { background: "var(--cp-surface)", color: "var(--cp-text)" },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: { border: "1px solid var(--cp-border)", boxShadow: "var(--cp-card-shadow)" },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          minHeight: 48,
          "&:hover, &.Mui-focusVisible": { backgroundColor: "var(--cp-accent-soft)" },
        },
      },
    },
    MuiLink: {
      styleOverrides: { root: { color: "var(--cp-link)" } },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <a className="skip-link" href="#main-content">Skip to content</a>
      <HideAppBar />
      <main id="main-content" tabIndex={-1}>
        <TopSection />
        <StaffedHoursAndClasses />
        <TopImageCarousel />
        <FeesAndPricing />
        <BottomImageCarousel />
        <JoinNow />
      </main>
      <Socials />
    </ThemeProvider>
  );
}

export default App;
